import feHelper from 'features/FE/feHelper';
import { setData } from 'features/FE/feSlice';
import KTImageInput from 'general/components/OtherKeenComponents/FileUpload/KTImageInput';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSButton, {
    KTBSButtonColor,
    KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _, { chain } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

function ChargeDriverTopupDetailScreen(props) {
    // ---- params ----
    const dispatch = useDispatch();
    const router = useRouter();
    const serialNumber = router.query?.serialNumber;
    const [topupCardDetail, setTopupCardDetail] = useState({});
    const [chargeDriverDetail, setChargeDriverDetail] = useState({});
    const refCardInfo = useRef();
    const [showTopupView, setShowTopupView] = useState(false);
    const baseUrl = window.location.origin;
    const [amount, setAmount] = useState(0);
    const [fundingSource, setFundingSource] = useState('');
    const [paymentMethodsList, setPaymentMethodsList] = useState([]);

    useEffect(() => {
        const handleGetGetTopupCardDetail = async () => {
            if (serialNumber && serialNumber?.length) {
                try {
                    const res = await feHelper.callApiGetTopupCardDetail({ serialNumber });
                    if (res) {
                        setTopupCardDetail({ ...topupCardDetail, ...(res.card ?? {}) });
                        setChargeDriverDetail(res?.card?.vehicle?.user)
                    }
                } catch (error) {
                    console.log('error: ', error);
                    ToastHelper.showError(error?.response?.data?.reason);
                }
            }
        };

        handleGetGetTopupCardDetail();
    }, [serialNumber]);

    useEffect(() => {
        const handleGetPaymentMethodList = async () => {
            const res = await miscHelper.callApiGetAppConfig();
            if (res) {
                const paymentConfig = res.config.find(item => item.key === "enablePaymentMethods_V2");
                const paymentMethods = JSON.parse(paymentConfig.value);
                setPaymentMethodsList(paymentMethods);
            }
        };

        handleGetPaymentMethodList();
    }, [])

    // ---- methods ----
    const buildRowItem = (name, value, valueColor = AppColors.gray[800]) => {
        return (
            <div className="d-flex justify-content-between px-4">
                <span
                    style={{
                        color: AppColors.gray[600],
                        fontWeight: '500',
                        fontSize: Utils.convertToFontSize(16),
                    }}
                >
                    {name}
                </span>
                <span
                    style={{
                        color: valueColor,
                        fontWeight: '600',
                        fontSize: Utils.convertToFontSize(16),
                    }}
                >
                    {value}
                </span>
            </div>
        );
    };

    const buildSeparator = () => {
        return (
            <div
                className="my-4"
                style={{
                    borderBottom: `1px dashed ${AppColors.gray[300]}`,
                }}
            ></div>
        );
    };

    const getPaymentMethodsLogo = (paymentMethod) => {
        switch (paymentMethod) {
            case 'BIDV':
                return AppResource.icons.tmt.icLogoQR;
            case 'BANK':
                return AppResource.icons.tmt.icLogoBank;
            case 'VNPAY':
                return AppResource.icons.tmt.icLogoVNPay;
            case 'MOMO':
                return AppResource.icons.tmt.icLogoMomo;
        }
    }

    const handleSubmit = async () => {
        if (!Utils.isValid(amount) || !Utils.isValid(fundingSource)) {
            ToastHelper.showError('Vui lòng nhập số tiền muốn nạp và chọn phương thức thanh toán');
            return;
        }
        if (Utils.isValid(amount) && amount <= 0) {
            ToastHelper.showError('Số tiền cần nạp phải lớn hơn 0');
            return;
        }
        const params = {
            amount,
            fundingSource,
            currency: 'VND',
            serialNumber,
            redirectUrl: fundingSource === 'VNPAY' ? `${baseUrl}/topup/${serialNumber}/payment` : ''
        };
        localStorage.setItem('serialNumber', serialNumber)
        handlePayment(params);
    };

    const handlePayment = async (params) => {
        try {
            const res = await feHelper.callApiTopupCard(params);
            if (res) {
                const { transaction, payment, qrData, expiryInSeconds, link } = res;
                if (res.result === 'success') {
                    if (link) {
                        window.location.href = link;
                    } else {
                        console.log({ qrData });
                        dispatch(setData(res));
                        router.navigate(`/topup/${serialNumber}/payment`);
                    }
                } else {
                    ToastHelper.showError(res.result);
                }
            }
        } catch (error) {
            console.log('error: ', error);
            ToastHelper.showError(error?.response?.data?.reason);
        }
    };

    return (
        <div
            className="min-vh-100 d-flex flex-column align-items-center justify-content-center pt-5"
            style={{
                backgroundImage: `url(${AppResource.images.tmt.bgAuthForm})`,
                backgroundSize: 'cover',
            }}
        >
            <div
                className="container px-0"
                style={{
                    paddingBottom: `${65 + 16}px`,
                }}
            >
                {/* header */}
                <div className="d-flex flex-column align-items-center px-5 py-10">
                    <div className="d-flex flex-column align-items-center">
                        <img alt="logo" src={AppResource.icons.tmt.evgLogoAuth} className="w-175px" />
                    </div>
                </div>

                <div
                    ref={refCardInfo}
                    className="p-5 bg-white mx-5"
                    style={{
                        border: `1px solid ${AppColors.gray[300]}`,
                        borderRadius: '10px',
                    }}
                >
                    {!showTopupView
                        ? (
                            <>
                                <div style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                                    Thông tin cá nhân
                                </div>
                                <div style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[700])}>
                                    Vui lòng kiểm tra thông tin cá nhân của bạn và xác nhận chính xác trước khi nạp tiền.
                                </div>
                                <div className="row mx-0 my-2 p-0">
                                    <div className="col-lg-3 col-md-4 col-4 p-0">
                                        <KTImageInput
                                            fullWidth={true}
                                            aspectRatio={'1'}
                                            name="avatar"
                                            editable={false}
                                            value={Utils.isValid(chargeDriverDetail?.avatar) ? Utils.getFullUrl(chargeDriverDetail?.avatar) : null}
                                            acceptImageTypes={['image/png', 'image/jpg', 'image/jpeg']}
                                            defaultImage={
                                                AppResource.images.chargeConnectorTypes.imgChargeStationBgDefault
                                            }
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                                <div
                                    className="py-4 mt-3 d-flex flex-column"
                                    style={{
                                        border: `1px solid ${AppColors.gray[300]}`,
                                        borderRadius: '5px',
                                    }}
                                >
                                    {buildRowItem('Họ và tên', chargeDriverDetail?.fullname)}
                                    {buildSeparator()}
                                    {buildRowItem('Số điện thoại', chargeDriverDetail?.phone)}
                                    {buildSeparator()}
                                    {buildRowItem('Email', chargeDriverDetail?.email)}
                                    {buildSeparator()}
                                    {buildRowItem('Số CCCD', chargeDriverDetail?.idCardNumber)}
                                </div>
                            </>
                        )
                        : (
                            <>
                                <div className='d-flex align-items-center gap-2'>
                                    <div>
                                        <img src={AppResource.icons.tmt.icWallet} alt="Ví tiền" />
                                    </div>
                                    <div>
                                        <div style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                            Tài khoản hiện tại
                                        </div>
                                        <div style={UIHelper.buildFontStyle('700', '26px', AppColors.primary)}>
                                            {Utils.formatNumber(chargeDriverDetail?.wallets?.[0]?.balance)} VNĐ
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                </div>
                {showTopupView && (
                    <div>
                        <div
                            className="p-5 bg-white mx-5 mt-4"
                            style={{
                                border: `1px solid ${AppColors.gray[300]}`,
                                borderRadius: '10px',
                            }}
                        >
                            <div style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])} className="mb-3">
                                Số tiền nạp
                            </div>

                            <div className="mb-4">
                                <div
                                    className="d-flex justify-content-between border rounded-lg"
                                    style={{
                                        borderColor: AppColors.gray[300],
                                    }}
                                >
                                    <div className='w-100 d-flex flex-column p-3' style={{ borderRight: `1px solid ${AppColors.gray[300]}` }}>
                                        <div>
                                            <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
                                                Số tiền muốn nạp
                                            </span>
                                            <span className="text-danger ml-1">*</span>
                                        </div>

                                        <KTFormInput
                                            name='amount'
                                            value={amount}
                                            onChange={(value) => {
                                                setAmount(value);
                                            }}
                                            enableCheckValid
                                            type={KTFormInputType.currency}
                                            placeholder={'Nhập số'}
                                            additionalInputClassName='border-0 text-success h3 font-weight-bold p-0 m-0'
                                            showUnit={false}
                                        />
                                    </div>

                                    <div className='w-80px d-flex justify-content-center align-items-center' style={UIHelper.buildFontStyle('400', '16px', AppColors.gray[800])}>
                                        VNĐ
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex flex-wrap gap-2">
                                {[
                                    { value: 100000, label: '100.000' },
                                    { value: 200000, label: '200.000' },
                                    { value: 300000, label: '300.000' },
                                    { value: 500000, label: '500.000' },
                                    { value: 1000000, label: '1.000.000' },
                                    { value: 2000000, label: '2.000.000' },
                                ].map((item) => (
                                    <div
                                        key={item.value}
                                        onClick={() => {
                                            setAmount(item.value);
                                        }}
                                        className="px-4 py-2 rounded-pill bg-white cursor-pointer transition-all"
                                        style={{
                                            ...UIHelper.buildFontStyle(
                                                '600',
                                                '14px',
                                                amount === item.value ? AppColors.primary : AppColors.gray[800]
                                            ),
                                            border: `1px solid ${amount === item.value ? AppColors.primary : AppColors.gray[300]}`,
                                            outline: 'none',
                                            transition: 'all 0.2s ease',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.border = `1px solid ${AppColors.primary}`;
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.border = `1px solid ${amount === item.value ? AppColors.primary : AppColors.gray[300]}`;
                                        }}
                                    >
                                        {item.label}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div
                            className="p-5 bg-white mx-5 mt-4"
                            style={{
                                border: `1px solid ${AppColors.gray[300]}`,
                                borderRadius: '10px',
                            }}
                        >
                            <div style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])} className="mb-3">
                                Phương thức thanh toán
                            </div>
                            <div className='d-flex flex-column gap-3'>
                                {paymentMethodsList?.map(item => (
                                    <div
                                        className='p-4 d-flex align-items-center gap-3 rounded-lg cursor-pointer'
                                        style={{ border: fundingSource === item.fundingSource ? `2px solid ${AppColors.primary}` : `1px solid ${AppColors.gray[300]}` }}
                                        onClick={() => setFundingSource(item.fundingSource)}
                                    >
                                        <img src={getPaymentMethodsLogo(item.fundingSource)} width={36} height={36} />
                                        <div style={UIHelper.buildFontStyle('500', '16px', AppColors.gray[800])}>
                                            {item.name}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="position-fixed bottom-0 zindex-5 mt-5">
                <div
                    className="mb-5"
                    style={{
                        width: `${refCardInfo.current?.offsetWidth}px`,
                        border: '1px solid #28CE7F',
                        boxShadow: '0px 7px 20px -3px #50FF9D40',
                        borderRadius: 10,
                    }}
                >
                    {!showTopupView
                        ? (
                            <KTBSButton
                                color={KTBSButtonColor.success}
                                title="Nạp tiền"
                                size={KTBSButtonSize.large}
                                borderRadius={8}
                                buttonTitleFontWeight="600"
                                onPress={() => setShowTopupView(true)}
                                additionalClassName="w-100"
                                buttonTitleFontSize={18}
                            />
                        )
                        : (
                            <KTBSButton
                                color={KTBSButtonColor.success}
                                title={
                                    <div>
                                        {amount ? (
                                            <>
                                                Thanh toán{' '}
                                                <span style={{ color: AppColors.primaryLight }}>
                                                    • {Utils.formatNumber(amount)} VNĐ
                                                </span>
                                            </>
                                        ) : <>Thanh toán</>}
                                    </div>
                                }
                                size={KTBSButtonSize.large}
                                borderRadius={8}
                                buttonTitleFontWeight="600"
                                onPress={() => handleSubmit()}
                                additionalClassName="w-100"
                                buttonTitleFontSize={18}
                            />
                        )}
                </div>
            </div>
        </div >
    );
}

export default ChargeDriverTopupDetailScreen;
